/**
 * Tiny synthesized UI sounds — no audio assets, all WebAudio oscillators.
 * Off by default; every sound always has a visual equivalent elsewhere in
 * the interface. Volume is deliberately low (peak gain ≈ 0.08).
 */

let ctx: AudioContext | null = null;
let enabled = false;

export function setSoundEnabled(value: boolean): void {
  enabled = value;
  if (value && !ctx && typeof AudioContext !== 'undefined') ctx = new AudioContext();
}

function tone(frequency: number, durationMs: number, type: OscillatorType, gainPeak: number, delayMs = 0): void {
  if (!ctx || !enabled) return;
  const start = ctx.currentTime + delayMs / 1000;
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, start);
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(gainPeak, start + 0.008);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + durationMs / 1000);
  oscillator.connect(gain).connect(ctx.destination);
  oscillator.start(start);
  oscillator.stop(start + durationMs / 1000 + 0.02);
}

/** Soft tick for toggles and light interactions. */
export function playTick(): void {
  tone(880, 40, 'sine', 0.05);
}

/** Two-note confirm for saved / completed actions. */
export function playConfirm(): void {
  tone(523.25, 90, 'sine', 0.07);
  tone(783.99, 140, 'sine', 0.07, 70);
}

/** Warm three-note arpeggio for session milestones. */
export function playChime(): void {
  tone(659.25, 160, 'sine', 0.06);
  tone(830.61, 160, 'sine', 0.06, 90);
  tone(987.77, 260, 'sine', 0.06, 180);
}

/** Gentle single low note when a focus block ends. */
export function playBell(): void {
  tone(440, 500, 'sine', 0.08);
  tone(880, 420, 'sine', 0.04, 30);
}
